<template>
    <span>
        <Input v-model="text" type="textarea" :rows="4" @on-change="changed"></Input>
    </span>
</template>
<script>
    export default {
        props: ["value"],
        data() {
            return {
                text: "",
                timer: null
            }
        },
        watch: {
            value: {
                handler(value) {
                    if (value != null) {
                        this.text = JSON.stringify(value)
                    } else {
                        this.text = '';
                    }

                },
                immediate: true
            }
        },
        computed: {

        },
        methods: {
            changed() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    try {
                        const obj = JSON.parse(this.text);
                        this.$emit("input", obj)
                    } catch (error) {
                        this.$emit("input", null)
                    }


                    this.$emit('save')
                }, 1000);

            }
        }
    }
</script>